import { DOCTOR_APP_URL } from './runtimeEnv.js';

// The clinic panel's doors into the DOCTOR panel — now only for what is the
// practitioner's own.
//
// The visit room and the patient record used to be reached here too, in a new
// tab. They are the shared clinical module now and open INSIDE this panel
// (screens/Clinical, docs/CLINICAL_KIT_DESIGN.md). What still lives only in the
// doctor panel is personal: the practitioner's پارسه wallet (the AI bills the
// person, not the clinic — the clinic's own top-up in «کلینیک من» would charge
// the wrong wallet) and their visit layout. A visit here that needs either sends
// them there, beside this panel, and the visit stays where it was.
//
// A plain navigation, not a token hand-off: same realm, so the doctor panel runs
// its own PKCE flow and the SSO session answers without a second sign-in.

/** The practitioner's پارسه top-up. */
export function doctorCreditsUrl() {
  return `${DOCTOR_APP_URL}/credits`;
}

/** The practitioner's visit-layout editor. */
export function doctorVisitLayoutUrl() {
  return `${DOCTOR_APP_URL}/profile?tab=visit`;
}

// A NEW tab, deliberately: the visit this was raised from must survive it.
// `noopener` because the other panel has no business holding a handle on this
// one. One function so leaving is observable in tests.
export function openDoctorPanel(url) {
  if (!url || typeof window === 'undefined') return false;
  window.open(url, '_blank', 'noopener,noreferrer');
  return true;
}

export const openDoctorCredits = () => openDoctorPanel(doctorCreditsUrl());
export const openDoctorVisitLayout = () => openDoctorPanel(doctorVisitLayoutUrl());

/**
 * The doctor panel's front door.
 *
 * Used by registration, where a doctor who has just been joined to the clinic
 * they founded is offered their OTHER panel beside this one — not sent to it.
 * No path: where a doctor lands on arrival is the doctor panel's decision, and
 * duplicating its routing here is how the two drift.
 */
export function doctorHomeUrl() {
  return `${DOCTOR_APP_URL}/`;
}
